import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

// Интерфейсы для типов данных
interface Check {
  id: string;
  checkId?: string;
  uuidCassandra?: string;
  iinBin: string;
  ofd: string;
  status: string;
  dateProcessing: string;
  consumer: string;
  note: string;
}

interface CheckListResponse {
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
  checks: Check[];
}

interface CheckListRequest {
  searchTerm?: string;
  fromDateTime?: string;
  toDateTime?: string;
  status?: string;
  ofdId?: number;
  consumerId?: number;
}

// Функция для получения списка чеков
export const getCheckList = async (
  page = 1,
  size = 10,
  requestBody: CheckListRequest = {}
): Promise<CheckListResponse> => {
  try {
    console.log(333, requestBody);
    
    const token = Cookies.get("access_token"); // Получение токена из cookies

    const response: AxiosResponse<CheckListResponse> = await apiClient.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/check/list`,
      requestBody,
      {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`, // Добавление Bearer токена
          "Content-Type": "application/json", // Указание типа контента
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Ошибка при получении списка чеков:", error);
    throw error;
  }
};

export const getErrorCheckList = async (
  page = 1,
  size = 10,
  requestBody: CheckListRequest = {}
): Promise<CheckListResponse> => {
  try {
    const token = Cookies.get("access_token"); // Получение токена из cookies

    const response: AxiosResponse<CheckListResponse> = await apiClient.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/check/list-ofd`,
      requestBody, // Тело запроса
      {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`, // Добавление Bearer токена
          "Content-Type": "application/json", // Указание типа контента
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Ошибка при получении списка чеков:", error);
    throw error;
  }
};

export const getConsumerList =async(
  page = 1,
  size = 10,)=>{
    try {
      const token = Cookies.get("access_token");
      const response =await apiClient.get (
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/consumer/list`,
        {
          params: { page, size },
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json", 
          },
        }
      )
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении списка чеков:", error);
      throw error;
    }
}

export const getOfdList =async(
  bin = '',
  page = 1,
  size = 10,)=>{
    try {
      const token = Cookies.get("access_token");
      const response =await apiClient.get (
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/ofd/list${bin ? `?bin=${bin}` : ''}`,
        {
          params: { page, size },
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json", 
          },
        }
      )
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении списка чеков:", error);
      throw error;
    }
}

export const getCheck =async(id:number)=>{
    try {
      const token = Cookies.get("access_token");
      const response =await apiClient.get (
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/check/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json", 
          },
        }
      )
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении списка чеков:", error);
      throw error;
    }
}

export const getErrorCheck =async(id:number)=>{
  try {
    const token = Cookies.get("access_token");
    const response =await apiClient.get (
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/check/ofd-error/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json", 
        },
      }
    )
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении списка чеков:", error);
    throw error;
  }
}

export const getReceivedCheck = async (id: string) => {
  try {
    const token = Cookies.get("access_token");
    const response = await apiClient.get(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/check/received/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json", 
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении полученного чека:", error);
    throw error;
  }
}

export const resendCheckList = async (
  requestBody:any
): Promise<CheckListResponse> => {
  try {
    const token = Cookies.get("access_token"); // Получение токена из cookies

    const response: AxiosResponse<CheckListResponse> = await apiClient.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/check/send`,
      requestBody, // Тело запроса
      {
        headers: {
          Authorization: `Bearer ${token}`, // Добавление Bearer токена
          "Content-Type": "application/json", // Указание типа контента
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Ошибка при получении списка чеков:", error);
    throw error;
  }
};

